module.exports = __webpack_public_path__ + "static/img/Jack_Viney_mobile.558e43c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack_Viney_mobile.jpg
// module id = h8vL
// module chunks = 0